import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export interface ProductOptionValues {
    option_name: string;
    option_values: string[]
}

export interface ProductOption {
    product: string
    option_values: ProductOptionValues[]
}

interface ProductOptionsResponse {
    options_values: ProductOption[]
}

const ProductOptionsAPI = {
    get : async () => {
        try {
            const response: AxiosResponse<ProductOptionsResponse> = await axiosInstance.get('/v1/product-options');
            return response.data.options_values;
        } catch(error) {
            console.error(error)
            return [];
        }
    }
}

export default ProductOptionsAPI;